import * as React from 'react'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { reverse } from 'named-urls'

import routes from 'bvdash/routes'
import { ThreeDotsMenu } from 'bvdash/ui/tables'
import { ConfirmStatusChange } from 'bvdash/actions/ui'

import { authUser } from 'bvdash/auth/queries'
import { startConversation } from 'bvdash/conversations/queries'
import { withNCRSetOpen } from 'bvdash/projects/queries'

function NCRContextMenu(props) {
  const {
    id,
    ncrId,
    projectKey,
    managerKey,
    assignedToKey,
    isOpen,
    canEdit,
    history,

    ncrSetOpen,
    startConversation,
    authUser,
    titles,
  } = props
  return (
    <ConfirmStatusChange titles={titles} type="ncr" isOpen={isOpen}>
      {confirm => (
        <ThreeDotsMenu
          actions={[
            {
              label: `Edit ${titles.quality}`,
              onClick: () =>
                history.push(
                  reverse(routes.project.ncrEdit, {
                    projectKey,
                    ncrId,
                  })
                ),
            },
            {
              label: `Reopen ${titles.quality}`,
              onClick: confirm(() => ncrSetOpen(id, true)),
              hide: !canEdit || isOpen,
            },
            {
              label: `Close ${titles.quality}`,
              onClick: confirm(() => ncrSetOpen(id, false)),
              hide: !canEdit || !isOpen,
            },
            {
              label: 'Contact Assignee',
              onClick: () => startConversation([assignedToKey]),
              hide: authUser.user && authUser.user.key === assignedToKey,
            },
            {
              label: 'Contact PM',
              onClick: () => startConversation([managerKey]),
              hide: authUser.user && authUser.user.key === managerKey,
            },
          ]}
        />
      )}
    </ConfirmStatusChange>
  )
}

export default compose(
  withRouter,
  authUser,
  withNCRSetOpen,
  startConversation
)(NCRContextMenu)
